<script>
    export let active = false;
    export let isIcon = false;
    export let isColon = false;
    export let isSpacer = false;
    export let isBigSpacer = false;
</script>

<style lang="less">
    @import "./common.less";

    .desktop ({
        div {
            flex: 1 1 0;
            box-sizing: border-box;
            display: flex;
            justify-content: center;
            align-items: center;
        }
        :global(div[data-icon="month"]) div[data-active] {
            text-shadow: 0 0 12px rgba(@brightFgR, @brightFgG, @brightFgB, 0.7);
        }
        span {
            flex: 0 0 auto;
        }
        div[data-active] {
            color: @brightFg;
        }
        div[data-colon], div[data-spacer], div[data-bigSpacer] {
            display: none;
        }
    });
    .mobile ({
        div:not([data-tiny]) {
            display: none;
        }
        div {
            flex: 0 0 auto;
        }
        div[data-colon] {
            padding: 0 5px 0 2px;
        }
        div[data-spacer] {
            width: 20px;
            flex: 0 0 auto;
        }
        div[data-bigSpacer] {
            flex: 1 1 0;
        }
    });
</style>

<div data-active={active ? '1' : null} data-colon={isColon ? '1' : null} data-spacer={isSpacer ? '1' : null} data-bigSpacer={isBigSpacer ? '1' : null} data-tiny={(active || isColon || isIcon || isSpacer || isBigSpacer) ? '1' : null}><span><slot/></span></div>